// import ProductHero from 'components/product/ProductHero';
import ProductDetails from 'components/product/ProductDetails';
import OrderSection from 'components/order/OrderSection';
import ProductStory from 'components/product/ProductStory';
import NutritionSection from 'components/product/NutritionSection';
import Button from 'components/ui/Button';
import SectionHeading from 'components/ui/SectionHeading';
import PageMeta from 'components/layout/PageMeta';

export const metadata = {
  title: 'Singaraa KHARISING | Premium 500g Peanuts',
  description: 'Discover Singaraa Dry Roasted Peanuts - crunchy, fresh, and naturally delicious. Order online directly via WhatsApp.',
};

export default function ProductPage() {
  return (
    <main className="min-h-screen bg-singaraa-ivory">
      <PageMeta title={metadata.title} description={metadata.description} />
      {/* <ProductHero /> */}
      <OrderSection
        id="order-now"
        eyebrow="DIRECT FROM FACTORY"
        title="Buy Singaraa Peanuts Online"
        subtitle="Select your preferred pack size and place your order directly via WhatsApp in less than 1 minute"
      />
      <ProductDetails />
      <ProductStory />
      <NutritionSection />

    </main>
  );
}
